/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationDto
 */
export interface EvaluationDto {
    /**
     * List of contract IDs to be evaluated
     * @type {Set<number>}
     * @memberof EvaluationDto
     */
    contractIds: Set<number>;
}

/**
 * Check if a given object implements the EvaluationDto interface.
 */
export function instanceOfEvaluationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contractIds" in value;

    return isInstance;
}

export function EvaluationDtoFromJSON(json: any): EvaluationDto {
    return EvaluationDtoFromJSONTyped(json, false);
}

export function EvaluationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contractIds': json['contractIds'],
    };
}

export function EvaluationDtoToJSON(value?: EvaluationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contractIds': Array.from(value.contractIds as Set<any>),
    };
}

